import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { sanityClient } from "../lib/sanityClient";

// Multilingual ArticleCard
const ArticleCard = ({ article, lang }) => {
  const title = article.title?.[lang] || article.title?.en;
  const slug = article.slug?.[lang]?.current || article.slug?.en?.current;
  const author = article.author?.[lang] || article.author?.en;

  return (
    <div className="border rounded-lg p-4 shadow-md">
      {article.primaryImage && (
        <img
          src={article.primaryImage}
          alt={title}
          className="w-full h-48 object-cover rounded-md"
        />
      )}
      <h2 className="text-xl font-semibold mt-2">{title}</h2>
      <p className="text-sm text-gray-600">
        By {author} | {new Date(article.publishedAt).toDateString()}
      </p>
      <Link
        to={`/cm/${lang}/articles/${slug}`}
        className="text-blue-500 mt-2 block"
      >
        Read More
      </Link>
    </div>
  );
};

const ArticlesList = ({ lang }) => {
  const [articles, setArticles] = useState([]);

  useEffect(() => {
    const fetchArticles = async () => {
      try {
        const query = `*[_type == "article"]{
          _id,
          title,
          slug,
          author,
          publishedAt,
          primaryImage
        }`;
        const data = await sanityClient.fetch(query);
        setArticles(data);
      } catch (error) {
        console.error("Error fetching articles:", error);
      }
    };
    fetchArticles();
  }, []);

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
      {articles.map((article) => (
        <ArticleCard key={article._id} article={article} lang={lang} />
      ))}
    </div>
  );
};

// Main ArticlesPage Component
const ArticlesPage = () => {
  const { lang } = useParams(); // expects route like /en/articles or /fr/articles

  return (
    <div className="container mx-auto p-4">
      <h1 className="text-3xl font-bold mb-6">
        {lang === "fr"
          ? "Articles récents"
          : lang === "es"
          ? "Artículos recientes"
          : lang === "ar"
          ? "أحدث المقالات"
          : "Latest Articles"}
      </h1>
      <ArticlesList lang={lang || "en"} />
    </div>
  );
};

export default ArticlesPage;
